import { CELL_HORIZONTAL_PADDING_PX } from '~components/DataTable/getColumnSlots';

// DataTable lays custom cells out shrink-to-fit, and an Autocomplete's input has no
// width of its own, so a `width: 100%` select collapses to a few characters. Every
// mapping select gets this fixed width instead. It stays under DataTable's 400px
// fitted column cap (less cell padding) so the select is never clipped.
export const MAPPING_SELECT_WIDTH_PX = 360;

export const MAPPING_COLUMN_MIN_WIDTH_PX =
  MAPPING_SELECT_WIDTH_PX + CELL_HORIZONTAL_PADDING_PX * 2;
